import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './ErrorPages.scss';

const NotFound = () => {

  const { t } = useTranslation();
  const navigate = useNavigate();

  const goHome = () => {
    navigate('/');
  };

  return (
    <div className="not-found-container">
      <h1 className="not-found-title">404</h1>
      <p className="not-found-message">{t('not_found_message')}.</p>
      <button className="not-found-button" onClick={goHome}>{t('go_home')}</button>
    </div>
  );
};

export default NotFound;
